export const CardItems = [
    {
        id: 'card-search-policy',
        image: 'assets/images/home/poliza.svg',
        label: 'Buscador de pólizas',
        link: 'buscador-poliza',
        hideForFeatureToggle: "cartera"
    },
    {
        id: 'card-search-policy-list',
        image: 'assets/images/home/briefcase-card.svg',
        label: 'Buscador de pólizas',
        link: 'polizas/cartera-sin-filtros',
        showForFeatureToggle: "cartera"
    },
    {
        id: 'card-quotations',
        image: 'assets/images/home/cotizaciones.svg',
        label: 'Cotizaciones',
        link: 'mis-cotizaciones',
        hideForFeatureToggle: "cotizaciones"
    },
    {
        id: 'card-quotations-list',
        image: 'assets/images/home/quotation-card.svg',
        label: 'Cotizaciones',
        link: 'polizas/cotizaciones',
        showForFeatureToggle: "cotizaciones"
    },
    {
        id: 'card-renovations',
        image: 'assets/images/home/renovaciones.svg',
        label: 'Renovaciones',
        link: 'centro-renovaciones',
        hideForFeatureToggle: 'renovaciones'
    },
    {
        id: 'card-renovations-list',
        image: 'assets/images/home/renovation-card.svg',
        label: 'Renovaciones',
        link: 'renovaciones',
        showForFeatureToggle: 'renovaciones'
    },
    {
        id: 'card-sinister',
        image: 'assets/images/home/siniestros.svg',
        label: 'Siniestros',
        link: 'siniestros',
    },
    {
        id: 'card-clients-debts',
        image: 'assets/images/home/deudas.svg',
        label: 'Clientes con deudas',
        link: 'clientes-con-deudas',
    },
    {
        id: 'card-payments',
        image: 'assets/images/home/cobranzas.svg',
        label: 'Cobranzas',
        link: 'cobranzas',
    }
];
